import { CatalogItem } from '../types/catalog';
export interface ProductCardProps {
  product: CatalogItem;
  storage: string;
  price:number;
}
export function CartProdInfo({ product,storage,price }: ProductCardProps) {
 const kv: Record<string, string> = Object.fromEntries(
    (product.props?.prop ?? []).map(p => [p.code, p.value])
  );
  const brand = kv['brand'] || '';
  const width = kv['width'] || '';
  const height = kv['height'] || kv['profile'] || '';
  const diameter = kv['diameter'] || '';
   const sizeLabel =
    width && height && diameter
      ? `${width}/${height} R${diameter}`
      : product.name || '';
return (
     <div className="flex-1 min-w-0">
                      <h4 className="font-medium text-xl truncate">{product.name}</h4>
                      <p className="text-lg text-gray-800">{product.code}</p>
                      <p className="text-lg text-gray-700">{storage}</p>
                      <p className="font-semibold text-lg">{price.toFixed(2)}₽</p>
    </div>
)
}